import { Component, ElementRef, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { StatsService } from 'src/app/services/stats.service';

import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-bar-chart-filtered-widget',
  templateUrl: './bar-chart-filtered-widget.component.html',
  styleUrls: ['./bar-chart-filtered-widget.component.scss']
})
export class BarChartFilteredWidgetComponent extends HomeWidget implements OnInit {
  public options: string[];
  public selected = -1;
  public filter: any;

  public reloadGraph: Subject<boolean> = new Subject();

  constructor(elRef: ElementRef, private stats: StatsService) {
    super(elRef);
  }

  public ngOnInit(): void {
    this.stats
      .fetchMetrics(
        this.settings.metric,
        false,
        [this.settings.selector],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => this.stats.filterNullColumn(data, [this.settings.selector]))
      .then(data => (this.options = data.map(d => d[this.settings.selector])));
  }

  public selectOption(i: number): void {
    this.selected = i;
    this.filter = {
      ...this.settings.filter,
      [this.settings.selector]: [this.options[i]]
    };
    setTimeout(() => this.reloadGraph.next(false), 100);
  }
}
